module.exports = __webpack_public_path__ + "static/icons/icon-copy-text--black-f94df2f14c4ed74c5de66ed21841847c.svg";